import React, {useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TerminalProgressBar from "./TerminalProgressBar"
import SignupTerminalInput from "./SignupTerminalInput"
import FirebaseContext from "../../../../common/firebase/context"

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        margin: "10px",
        border: "white solid 2px",
        background: "#182027"
    },
    description: {
        textAlign: 'center',
        marginBottom: "20px"
    },
    loginBarDiv: {
        display: "flex",
        justifyContent: "center"
    },
    logo: {
        width: "60px",
        height: "60px",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 20
    },
    content: {
        background: "white"
    },
    progressDiv: {
        display: "flex",
        alignContent: "center",
        marginTop: "20px",
        marginBottom: "20px",
        flexDirection: "column"
    },
    loginSpan: {
        textAlign: "center",
        marginTop: 20,
        marginBottom: 20
    }

});

const TerminalLoginCTA = ({logo, progress, chunkUid, isRenegadeOS}) => {
    const classes = useStyles();
    const {user} = useContext(FirebaseContext)

    const getSpan = () => {
        if (!user && isRenegadeOS) {
            return <span className={classes.loginSpan}>Login to save your progress, and return later.</span>
        }
        else return null
    }


    return (
        <div>
            <div className={classes.progressDiv}>
                {isRenegadeOS && <img src={logo} alt="Renegade OS" className={classes.logo}/>}
                {isRenegadeOS && <TerminalProgressBar value={progress} />}
                {/*{getSpan()}*/}
                {/*{!user && isRenegadeOS && <SignupTerminalInput chunkUid={chunkUid}/>}*/}
            </div>
        </div>
    );
}


export default TerminalLoginCTA
